import { useContext } from 'react';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { RcnUserContext } from 'src/context/RcnUser/RcnUserContext';

import { logoutRequest } from 'src/services/account/logoutRequest';

import { AuthenticatedUserProfile } from 'src/types/AuthenticatedUserProfile';

import { clearLocalStorage } from 'src/utils/clearLocalStorage';

import { Button } from 'src/components/basicContent/_Button/Button';

import LogoutSvg from 'public/icons/logout.svg';

import styles from './_LoggedInButtons.module.css';

type LoggedInButtonsProps = {
	LogOutText?: Field<string>;
	authenticatedUserProfile?: AuthenticatedUserProfile;
	menuTriggerId?: string;
};

export default function LoggedInButtons(props: LoggedInButtonsProps): JSX.Element {
	const RcnUser = useContext(RcnUserContext);
	const menuTriggerEl = props.menuTriggerId ? (document.getElementById(props.menuTriggerId) as HTMLInputElement) : null;

	if (!RcnUser.authenticatedUserProfile) {
		return <></>;
	}

	async function logout() {
		const loggedOut = await logoutRequest();

		if (loggedOut) {
			RcnUser.updateAuthenticatedUserProfile(undefined);
			clearLocalStorage();

			if (menuTriggerEl) {
				menuTriggerEl.checked = false;
			}

			window.location.reload();
		} else {
			console.error('Failed to log out user');
		}
	}

	return props.authenticatedUserProfile ? (
		<Button title="Logout" className={`button pinkDark ${styles.loggedInButton}`} onClick={logout}>
			<Text field={props.LogOutText} />

			<LogoutSvg className={styles.icon} />
		</Button>
	) : (
		<></>
	);
}
